<template>
  <div class="bg-white px-4 py-5 sm:p-4">
    <div class="text-xl font-bold" style="text-align: center;">
      Liquidaciones Embargo N° Proceso: <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
    </div>
  </div>

  <div class="bg-white px-3 py-4 sm:p-4">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold">
        Valor Inicial Embargo: <b style="color: #0e9f6e;"> {{ vueNumberFormat(data.valor_inicial, {}) }}</b>
      </div>

      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')"
        class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nueva Liquidación
      </button>

      <div class="flex gap-x-3 mt-3 sm:mt-0">
        <button @click="downloadGeneralReport()"
          class="px-4 py-2 text-white bg-blue-500 w-full sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          Descargar Consolidado
        </button>

        <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
          class="px-4 py-2 text-white bg-green-500 w-full sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
          </svg>
          <span class="ml-3">Volver</span>
        </button>
      </div>

    </div>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
        <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">

          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            NúMERO LIQUIDACIóN
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Fecha liquidación
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            LIMITE EMBARGO
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Valor aplicado
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            saldo actual
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Formato Pago
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium"
          v-for="(dataLiquidacion, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataLiquidacion.id }}
          </td>
          <td class="px-4 py-4">
            {{ dateTime(dataLiquidacion.created_at) }}
          </td>
          <td class="px-4 py-4">
            {{ vueNumberFormat(data.valor_inicial, {}) }}
          </td>
          <td class="px-4 py-4">
            {{ vueNumberFormat(dataLiquidacion.valor, {}) }}
          </td>
          <td class="px-4 py-4"
            :style="dataLiquidacion.saldo_actual > 0 ? 'color: #427de3; font-weight: 800;' : 'color:#0e9f6e; font-weight: 800;'">
            {{ vueNumberFormat(dataLiquidacion.saldo_actual, {}) }}
          </td>
          <td class="px-4 py-4">
            <button @click="downloadReportFinal(dataLiquidacion.id)"
              class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
              </svg>
              <span class="ml-3">Descargar Liquidación</span>
            </button>
            <button @click="generarDocumentoLiquidacion(dataLiquidacion)"
              class="mt-1 px-4 py-2 text-white bg-purple-500 w-full rounded-md hover:bg-purple-600 focus:outline-none">
              <span>Generar documento para firma</span>
            </button>
          </td>
          <td class="px-4 py-4">
            <button v-if="dataLiquidacion.estado == 1" @click="updateStateLiquidacion(dataLiquidacion.id)"
              class="items-center px-4 py-2 text-white bg-red-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-red-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                </path>
              </svg>
            </button>
            <button v-else @click="updateStateLiquidacion(dataLiquidacion.id)"
              class="items-center px-4 py-2 text-white bg-green-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"></path>
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6">
      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion" class="block text-sm font-medium text-gray-700">Demandado</label>
          <input type="text" id="rp" v-model="demandado"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="num_titulo" class="block text-sm font-medium text-gray-700">Saldo Actual</label>
          <input type="text" id="num_titulo" v-model="saldo_actual"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="id_modalidad" class="block text-sm font-medium text-gray-700">Modalidad de liquidación <span
              style="color: red">(*)</span></label>
          <select id="id_modalidad" v-model="selectedModalidad"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="" disabled>Seleccione una modalidad...</option>
            <option v-for="modalidad of collectionModalidades" :key="modalidad.id" :value="modalidad.id">
              {{ modalidad.nombre }}
            </option>
          </select>
        </div>
        <div v-if="modalidadSeleccionada && modalidadSeleccionada.tipo_calculo !== 'manual'"
          class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="base_calculo" class="block text-sm font-medium text-gray-700">Base de cálculo (salario / contrato / honorarios) <span
              style="color: red">(*)</span></label>
          <input v-model="base_calculo" id="base_calculo"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            type="text" />
          <p class="mt-1 text-xs text-gray-500">El valor a liquidar se calculará automáticamente según la modalidad seleccionada.</p>
        </div>
        <div v-if="!modalidadSeleccionada || modalidadSeleccionada.tipo_calculo === 'manual'"
          class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="num_titulo" class="block text-sm font-medium text-gray-700">Valor a Liquidar <span
              style="color: red">(*)</span></label>
          <input v-model="valor" id="valor"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            type="text" />
          <!-- <input type="number" id="num_titulo" v-model="valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"> -->
        </div>
      </div>
    </div>
    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()"
        class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import { saveUpdateData } from "@/layouts/main";
import { computed, ref, watch, nextTick } from "vue";
import { useAPIRest } from "@/common/constants";
import moment from 'moment';
import Swal from "sweetalert2";
import { utils, writeFile } from "xlsx-js-style";
import { separateNumberByComma, separateNumberByCommaInput, downloadLiquidacionEmbargo } from "@/common/constants/functions";

export default {
  name: 'LiquidacionesEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {
    const viewInterna = ref('list');
    const demandado = ref((props.data.demandado.primer_nombre || '') + ' ' + (props.data.demandado.segundo_nombre || '') + ' ' + (props.data.demandado.primer_apellido || '') + ' ' + (props.data.demandado.segundo_apellido || ''));
    const saldo_actual = ref(separateNumberByCommaInput(props.data.valor_actual));
    const valor = ref('');
    const collectionData = ref([]);
    const dataReport = ref('');
    const collectionModalidades = ref([]);
    const selectedModalidad = ref('');
    const base_calculo = ref('');

    const modalidadSeleccionada = computed(() =>
      collectionModalidades.value.find((modalidad) => modalidad.id == selectedModalidad.value)
    );

    const listModalidades = async () => await useAPIRest(process.env.VUE_APP_NEST_MODALIDADES_LIQUIDACION_FINDALL, 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
        collectionModalidades.value = Array.isArray(res) ? res.filter((modalidad) => modalidad.estado) : [];
      });

    listModalidades();

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
    }

    const customSaveData = async () => {
      try {

        const usaCalculoAutomatico = modalidadSeleccionada.value && modalidadSeleccionada.value.tipo_calculo !== 'manual';

        let dataSave = {
          id_embargo_persona: props.data.id,
        }

        if (!selectedModalidad.value) {
          Swal.fire({
            title: 'Debe seleccionarse la modalidad de liquidación! <br>',
            icon: 'error',
            showCloseButton: true,
            focusConfirm: false,
          })
          return;
        }

        dataSave.id_modalidad = selectedModalidad.value;

        if (usaCalculoAutomatico) {
          const baseCalculoNumerica = parseFloat((base_calculo.value || '').replaceAll(',', ''));

          if (isNaN(baseCalculoNumerica) || baseCalculoNumerica <= 0) {
            Swal.fire({
              title: 'La base de cálculo es obligatoria y debe ser superior a 0! <br>',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          dataSave.base_calculo = baseCalculoNumerica;
        } else {

          dataSave.valor = valor.value.replaceAll(',', '');

          if (dataSave.valor == '') {
            Swal.fire({
              title: 'El campo Valor a liquidar debe ser superior a 0! <br>',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          if (parseFloat(valor.value.replaceAll(',', '')) < 0) {
            Swal.fire({
              title: 'Error',
              icon: 'error',
              text: 'El valor no puede ser negativo.',
              showCloseButton: true,
              focusConfirm: false,
            })

            return;
          }

          if (Math.trunc(parseFloat(saldo_actual.value.replaceAll(/[,]/g, ''))) < valor.value.replaceAll(',', '')) {
            Swal.fire({
              title: 'Error',
              icon: 'error',
              text: 'El valor a liquidar no puede ser superior al saldo actual.',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }
        }

        let listApi = {
          create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_LIQUIDACION,
          list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_LIQUIDACION,
        };

        const resJSON = await saveUpdateData({
          listApi,
          authToken: props.authToken,
          loadData: dataSave,
          action: 'crear',
          entity: props.entity,
          view: 'crear',
        }, undefined, false, false, true);

        console.log('resJSON', resJSON);

        if (resJSON.statusCode == 200 || resJSON.statusCode == 201) {
          viewInterna.value = 'list'
          valor.value = '';
          base_calculo.value = '';
          selectedModalidad.value = '';
          dataReport.value = resJSON;
          saldo_actual.value = separateNumberByCommaInput(resJSON.saldo_actual.toString());
        }

        listData();

      } catch (error) {
        Swal.fire({
          title: 'Error al guardar',
          icon: 'error',
          showCloseButton: true,
          focusConfirm: false,
        })
        console.error('Error al guardar:', error);
      }
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_LIQUIDACION.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
        collectionData.value = res;
      });

    listData();

    const handleButtonClick = () => {
      emit('updateValues', { view: 'listar' });
      emit('watchList', { parametro: 'valor' });
    }

    const downloadReportFinal = async (liquidacion) => useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_LIQUIDACION_REPORTE.replace(':id', liquidacion), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
        // STEP 1: Create a new workbook
        const wb = utils.book_new();

        // --- Estilos base reutilizables (esquema plantilla oficial) ---
        const borde = { style: 'thin', color: { rgb: '000000' } };
        const bordes = { top: borde, bottom: borde, left: borde, right: borde };
        const AMARILLO = { fgColor: { rgb: 'FFFF00' } };

        const encabezado = (texto) => [
          { v: texto, t: 's', s: { font: { bold: true, size: 12 }, alignment: { horizontal: 'center', vertical: 'center' }, border: bordes } },
          { v: '', t: 's', s: { border: bordes } },
        ];

        // Fila etiqueta | valor. money => formato $; resaltar => celda amarilla a diligenciar.
        const fila = (label, valor, { money = false, resaltar = false } = {}) => [
          { v: label, t: 's', s: { font: { bold: true, size: 11 }, alignment: { wrapText: true, vertical: 'center' }, border: bordes } },
          {
            v: money ? Number(valor || 0) : (valor ?? ''),
            t: money ? 'n' : 's',
            s: {
              numFmt: money ? '$#,##0.00' : undefined,
              alignment: { horizontal: money ? 'right' : 'center', wrapText: true, vertical: 'center' },
              fill: resaltar ? AMARILLO : undefined,
              border: bordes,
            },
          },
        ];

        const fechaLiq = res.fecha_liquidacion ? String(res.fecha_liquidacion).split('T')[0] : '';

        const tableRows = [
          encabezado('DIRECCIÓN FINANCIERA DE TESORERÍA'),
          encabezado('LIQUIDACIÓN MEDIDA EMBARGO'),
          fila('Fecha liquidación', fechaLiq),
          fila('Número y fecha oficio medida embargo', res.numero_fecha_oficio),
          fila('Despacho judicial', res.despacho_judicial),
          fila('Jurisdicción', res.jurisdiccion),
          fila('Tipo proceso', res.tipo_proceso),
          fila('Radicado proceso', res.radicado_proceso),
          fila('Nombre e identificación demandante', res.demandante),
          fila('Nombre e identificación demandado', res.demandado),
          fila('Cuenta depósito judicial', res.cuenta_deposito_judicial, { resaltar: true }),
          fila('Contrato No', res.contrato_no, { resaltar: true }),
          fila('Fecha contrato', res.fecha_contrato, { resaltar: true }),
          fila('Orden de pago No', res.orden_pago_no, { resaltar: true }),
          fila('Fecha orden de pago', res.fecha_orden_pago, { resaltar: true }),
          fila('Valor orden de pago (antes de descuentos)', res.valor_orden_pago, { money: true }),
          fila('Factores liquidación embargo', res.factores),
          fila('25% honorario mensual', res.honorario_mensual, { money: true }),
          fila('Límite medida embargo', res.limite_embargo, { money: true }),
          fila('Valor aplicado pagos anteriores', res.valor_aplicado_anteriores, { money: true }),
          fila('Valor aplicado al presente pago', res.valor_aplicado_actual, { money: true }),
          fila('Saldo', res.saldo, { money: true }),
          fila('Revisado por', res.revisado_por, { resaltar: true }),
          fila('Autorizado por', res.autorizado_por),
        ];

        const ws = utils.aoa_to_sheet(tableRows);
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } },
        ];
        ws['!cols'] = [{ wch: 42 }, { wch: 42 }];
        utils.book_append_sheet(wb, ws, 'Liquidación');
        writeFile(wb, 'liquidacion_embargo_consecutivo_' + res.consecutivo + '.xlsx');
      });

    watch(() => valor.value, (newSaldoInicial) => {
      nextTick(() => valor.value = separateNumberByCommaInput(newSaldoInicial));
    })

    watch(() => base_calculo.value, (newBaseCalculo) => {
      nextTick(() => base_calculo.value = separateNumberByCommaInput(newBaseCalculo));
    })

    const updateStateLiquidacion = async (idLiquidacion) => {
      await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATESTATE_LIQUIDACION.replace(':id', idLiquidacion), 'PATCH', props.authToken, undefined, undefined, 'application/json')
        .then((res) => {
          if (res.error) {
            Swal.fire({
              icon: 'error',
              title: 'Precaución',
              text: 'La liquidación no posee saldo hábil para descontar.',
              showConfirmButton: true,
            })
          } else {
            Swal.fire({
              title: 'Exitoso',
              text: res.estado ? 'Liquidación Activada con éxito' : 'Liquidacion Desactivada con éxito',
              icon: 'success',
              showConfirmButton: true,
            })
            res.estado ? saldo_actual.value = (+saldo_actual.value.replaceAll(',', '') - +res.valor) : saldo_actual.value = (+saldo_actual.value.replaceAll(',', '') + +res.valor);
            saldo_actual.value = separateNumberByCommaInput(saldo_actual.value.toString())
          }
          listData();

        })
    }

    const downloadGeneralReport = async () => {
      await useAPIRest(process.env.VUE_APP_NEST_EMBARGO_PERSONA_EXPORT_LIQUIDACIONES.replace(':id',props.data.id),'GET',props.authToken, undefined, undefined, 'application/json')
        .then(res => {
          const wb = utils.book_new();
          let content = []
          let headers = [
            [
              { v: "NÚMERO EMBARGO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "NÚMERO LIQUIDACIÓN", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "FECHA LIQUIDACIÓN", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "LIMITE EMBARGO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "VALOR APLICADO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "SALDO ACTUAL", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "ESTADO LIQUIDACIÓN", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
            ],
          ]
            res.forEach(element => {
              content = [ ...content,
                [
                  { v: element.embargos.numero_proceso, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.id, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.created_at.split('T')[0], t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.embargos.valor_inicial), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.valor), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.saldo_actual), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.estado ? 'ACTIVO' : 'INACTIVO', t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },

                ],
               
              ];
            });
          const excel = headers.concat(content)
          
          const ws = utils.aoa_to_sheet(excel);

          ws['!cols'] = Array(headers[0].length).fill({ wch: 40 });

          utils.book_append_sheet(wb, ws, 'LIQUIDACIONES');

          writeFile(wb, `Información_liquidaciones_embargo_${res[0].embargos.numero_proceso}.xlsx`);
        });
    }

    const generarDocumentoLiquidacion = async (dataLiquidacion) => {
      try {
        const liquidacion = { ...dataLiquidacion };
        if (!liquidacion.modalidad && liquidacion.id_modalidad) {
          liquidacion.modalidad = collectionModalidades.value.find((modalidad) => modalidad.id == liquidacion.id_modalidad);
        }
        await downloadLiquidacionEmbargo(liquidacion, props.data);
      } catch (error) {
        console.error('Error al generar el documento de la liquidación:', error);
      }
    }

    return {
      changeView,
      viewInterna,
      demandado,
      saldo_actual,
      valor,
      collectionModalidades,
      selectedModalidad,
      modalidadSeleccionada,
      base_calculo,
      customSaveData,
      collectionData,
      listData,
      handleButtonClick,
      dataReport,
      downloadReportFinal,
      updateStateLiquidacion,
      downloadGeneralReport,
      generarDocumentoLiquidacion,
    }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm');
    }
  },
}

</script>
